/* tslint:disable */
import * as React from 'react';
/* tslint:enable */
import { css } from '../../../Utilities';
import { Icon } from '../../../Icon';
import * as stylesImport from './TagItem.scss';
var styles = stylesImport;
export var TagItem = function (props) { return (React.createElement("div", { className: css('ms-TagItem', styles.root, { 'is-selected': props.selected }, props.selected && styles.isSelected), role: 'listitem', key: props.index, "data-selection-index": props.index, "data-is-focusable": (props.enableTagFocusInDisabledPicker || !props.disabled) && true },
    React.createElement("span", { className: css('ms-TagItem-text', styles.tagItemText), "aria-label": props.children }, props.children),
    !props.disabled && (React.createElement("span", { className: css('ms-TagItem-close', styles.tagItemClose), onClick: props.onRemoveItem },
        React.createElement(Icon, { iconName: "Cancel" }))))); };
//# sourceMappingURL=TagItem.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/pickers/TagPicker/TagItem.js
// module id = 334
// module chunks = 0